import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitomahabaleshwarcab() {



const cardData = {
  keyword: " Mumbai to Mahabaleshwar Cab ",

headingDescription: "Velocity Cab provides reliable and comfortable Mumbai to Mahabaleshwar cab services, offering a scenic and stress‑free travel experience to one of Maharashtra’s most popular hill stations. Our professional drivers, well‑maintained vehicles, and punctual pickups ensure an enjoyable journey from Mumbai to Mahabaleshwar. We offer flexible booking options including one‑way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air‑conditioned sedans, spacious SUVs, and luxury cars suitable for solo travelers, families, and corporate clients. With easy online booking and 24/7 customer support, Velocity Cab is the trusted choice for Mumbai to Mahabaleshwar cab travel.",

topPlaces: [
  {
    title: "Arthur’s Seat",
    description: "Arthur’s Seat is one of the most famous viewpoints in Mahabaleshwar, known for its breathtaking views of the valleys and mountains. Travelers from Mumbai can take a cab to this vantage point to witness panoramic landscapes, especially at sunrise and sunset. The misty hills and rolling valleys make it perfect for photography, quiet reflection, and nature walks. Nearby vendors also offer local snacks and tea to enjoy while soaking in the scenery."
  },
  {
    title: "Venna Lake",
    description: "Venna Lake is a serene man‑made lake surrounded by lush greenery and hills. Visitors from Mumbai can enjoy boating on the calm waters, horse rides around the lake, and peaceful picnics by the shore. The area also features food stalls serving local delicacies and refreshments. It’s a favorite spot for families, couples, and solo travelers seeking relaxation amidst nature."
  },
  {
    title: "Mapro Garden",
    description: "Mapro Garden is a vibrant tourist attraction near Mahabaleshwar famous for its strawberry farms, fruit products, and scenic ambiance. Travelers arriving from Mumbai by cab can explore the lush gardens, enjoy fresh strawberry juice and treats, and shop for jams, preserves, and sweets. The garden also has seating areas and fountains, making it a pleasant stop for refreshments and photos."
  },
  {
    title: "Elephant’s Head Point",
    description: "Elephant’s Head Point is a striking rock formation resembling the head of an elephant, offering stunning views of the Sahyadri ranges and valleys. Cab travelers from Mumbai can enjoy panoramic views and crisp hill station air. The viewpoint is ideal for photography, watching the sunrise or sunset, and spending quiet moments surrounded by scenic beauty."
  },
  {
    title: "Pratapgarh Fort",
    description: "Pratapgarh Fort is a historic fort near Mahabaleshwar that offers a peek into India’s Maratha history and strategic architecture. Travelers from Mumbai can explore the fort’s rugged walls, ancient structures, and hilltop views overlooking the surrounding landscapes. The drive to Pratapgarh Fort is scenic, with winding roads, lush forests, and misty hills enhancing the journey."
  },
  {
    title: "Kate’s Point",
    description: "Kate’s Point is a popular viewpoint offering uninterrupted views of the Krishna Valley and Dhom Dam backwaters. Travelers arriving from Mumbai by cab can relax at this spot, take in the breathtaking scenery, and capture memorable photographs. The cool breeze and panoramic views make it a refreshing stop during the Mahabaleshwar trip."
  },
  {
    title: "Lingmala Waterfall",
    description: "Lingmala Waterfall is a picturesque waterfall located amidst lush greenery, especially striking during the monsoon season. Visitors from Mumbai can take a cab to Mahabaleshwar and enjoy the trek to the waterfall, listen to the sound of cascading water, and appreciate the tranquil surroundings. The viewpoint areas are perfect for nature photography and peaceful relaxation."
  },
  {
    title: "Wilson Point",
    description: "Wilson Point, also known as the Sunrise Point, is the highest point in Mahabaleshwar, offering spectacular sunrise views. Travelers from Mumbai can reach this spot early in the morning to witness the first light spreading over the hills. The cool climate and elevated location provide refreshing views and excellent opportunities for reflection and photography."
  },
  {
    title: "Cambridge Point",
    description: "Cambridge Point is another scenic viewpoint near Mahabaleshwar offering wide views of the valleys and hills. Cab travelers from Mumbai can stop here to enjoy the panoramic vistas and take pictures of the landscape stretching into the distance. The viewpoint is relatively peaceful, making it ideal for calm moments and nature appreciation."
  },
  {
    title: "Bombay Point",
    description: "Bombay Point is a beautiful sunset viewpoint in Mahabaleshwar where travelers from Mumbai can enjoy the golden hues over the valleys and hills. It’s an ideal spot for evening walks, photography, and spending quiet time surrounded by nature. The viewpoint is easily accessible and attracts visitors throughout the year."
  }
],



services: [
{
name: "Mumbai to Mahabaleshwar Cab Service",
description: "Mumbai to Mahabaleshwar cab service offers a smooth and scenic journey to one of Maharashtra’s most popular hill stations. This service is ideal for families, couples, and corporate travelers looking for a comfortable road trip from Mumbai. The route passes through beautiful ghats and lush greenery, making the journey as enjoyable as the destination. Professional drivers experienced in hill driving ensure safety and comfort throughout the trip. Customers can choose from sedan, SUV, or luxury vehicles based on their travel needs and group size. Flexible pickup options from home, airport, or railway station add convenience to the travel experience. With easy booking, transparent pricing, and 24x7 availability, this cab service ensures a stress-free and memorable Mahabaleshwar trip."
},
{
name: "Mumbai to Mahabaleshwar Taxi",
description: "Mumbai to Mahabaleshwar taxi service provides reliable and comfortable transportation for travelers planning a hill station getaway. Well-maintained vehicles and experienced drivers ensure a safe and relaxing journey through winding ghat roads. The service is suitable for both leisure and corporate travel with flexible scheduling options. Travelers can enjoy door-to-door pickup and drop, avoiding the hassle of public transport. With multiple vehicle choices and affordable pricing, this taxi service is a preferred option for a smooth trip. Advance booking options make travel planning easier and more convenient."
},
{
name: "One Way Cab Mumbai to Mahabaleshwar",
description: "One way cab Mumbai to Mahabaleshwar is a cost-effective option for travelers who need a single-side drop without return charges. This service is perfect for tourists planning extended stays or onward travel from Mahabaleshwar. Customers benefit from competitive pricing, flexible pickup timing, and comfortable vehicles. Professional drivers ensure timely arrival and safe navigation through hill routes. The service supports multiple vehicle options including sedan and SUV. Easy online booking and instant confirmation make it highly convenient."
},
{
name: "Mumbai to Mahabaleshwar Cab Fare",
description: "Mumbai to Mahabaleshwar cab fare is designed to be transparent and budget-friendly, allowing travelers to plan their trip without hidden charges. Pricing varies based on vehicle type, distance, and travel duration, ensuring flexibility for all budgets. Customers receive clear cost breakdowns including tolls and driver allowance where applicable. This helps in better financial planning for both one way and round trips. Affordable fare options are available for sedan, SUV, and premium vehicles. With competitive pricing and reliable service, travelers get the best value for money."
},
{
name: "Mumbai to Mahabaleshwar Round Trip Cab",
description: "Mumbai to Mahabaleshwar round trip cab service is ideal for travelers planning a return journey after exploring the hill station. This package includes pickup, drop, and return travel with flexible stay duration. Travelers can enjoy sightseeing without worrying about return transport arrangements. Professional drivers ensure timely service and safe driving throughout the journey. Multiple vehicle options are available for families and groups. This service offers convenience, comfort, and cost efficiency for complete travel planning."
},
{
name: "Cheap Cab Mumbai to Mahabaleshwar",
description: "Cheap cab Mumbai to Mahabaleshwar provides budget-friendly travel solutions without compromising on comfort and safety. This service is perfect for cost-conscious travelers who want reliable transportation at affordable rates. Well-maintained vehicles and professional drivers ensure a smooth journey. Customers can choose economical sedan options for lower fares. Transparent pricing and no hidden charges make this service highly popular. It is an ideal choice for students, small families, and solo travelers."
},
{
name: "Mumbai to Mahabaleshwar Outstation Taxi",
description: "Mumbai to Mahabaleshwar outstation taxi service offers long-distance travel with comfort and reliability. Designed for tourists and business travelers, this service ensures smooth highway travel with experienced drivers. Vehicles are regularly maintained for safety and performance. Flexible booking options and multiple pickup points add convenience. Travelers can choose between one way and round trip packages. This service ensures a hassle-free and enjoyable journey."
},
{
name: "Mumbai to Mahabaleshwar Sedan Cab",
description: "Mumbai to Mahabaleshwar sedan cab is perfect for small families and couples looking for an affordable and comfortable ride. Sedans offer smooth travel, good mileage, and comfortable seating for long journeys. This option is ideal for budget-friendly travel without compromising on convenience. Professional drivers ensure safe driving on highways and ghat roads. Easy booking and flexible timing enhance the travel experience. It is one of the most popular choices for this route."
},
{
name: "Mumbai to Mahabaleshwar SUV Taxi",
description: "Mumbai to Mahabaleshwar SUV taxi is ideal for group travel and those seeking extra space and comfort. SUVs provide better road grip and performance on hilly terrains, making them suitable for this route. Spacious interiors ensure comfortable seating and luggage capacity. This option is perfect for families, friends, and corporate groups. Drivers are trained for long-distance and hill driving. It ensures a premium and safe travel experience."
},
{
name: "Mumbai to Mahabaleshwar Car Rental",
description: "Mumbai to Mahabaleshwar car rental service provides flexible travel solutions with multiple vehicle options. Customers can rent cars based on their preferences for one way or round trips. This service is suitable for personal, family, and business travel needs. Easy booking process and transparent pricing make it convenient for all users. Vehicles are clean, well-maintained, and driven by professional chauffeurs. It ensures a comfortable and customized travel experience."
},
{
name: "Book Mumbai to Mahabaleshwar Cab Online",
description: "Book Mumbai to Mahabaleshwar cab online for quick and hassle-free reservations with instant confirmation. Online booking platforms allow customers to select vehicle types, travel dates, and pickup locations easily. This ensures better planning and availability of preferred vehicles. Transparent pricing and secure payment options enhance customer trust. 24x7 support is available for assistance during booking and travel. It is the most convenient way to plan your trip."
},
{
name: "AC Taxi Mumbai to Mahabaleshwar",
description: "AC taxi Mumbai to Mahabaleshwar ensures a comfortable journey in all weather conditions with fully air-conditioned vehicles. This service is ideal for long-distance travel, providing a relaxing environment throughout the trip. Well-maintained AC systems and clean interiors enhance passenger comfort. Suitable for families, tourists, and business travelers. Flexible pickup options add convenience. It guarantees a pleasant travel experience."
},
{
name: "Private Cab Mumbai to Mahabaleshwar",
description: "Private cab Mumbai to Mahabaleshwar offers a personalized travel experience with exclusive vehicle usage. This service is perfect for families and groups who prefer privacy and flexibility. Travelers can customize routes, stops, and travel schedules as per their needs. Professional drivers ensure safe and timely travel. Comfortable vehicles and premium service enhance the overall journey. It is the best choice for a relaxed and customized trip."
}
],

tableData: [
["Mumbai to Mahabaleshwar Cab Service","Mumbai to Mahabaleshwar Taxi"],
["One Way Cab Mumbai to Mahabaleshwar","Mumbai to Mahabaleshwar Cab Fare"],
["Mumbai to Mahabaleshwar Round Trip Cab","Cheap Cab Mumbai to Mahabaleshwar"],
["Mumbai to Mahabaleshwar Outstation Taxi","Mumbai to Mahabaleshwar Sedan Cab"],
["Mumbai to Mahabaleshwar SUV Taxi","Mumbai to Mahabaleshwar Car Rental"],
["Book Mumbai to Mahabaleshwar Cab Online","AC Taxi Mumbai to Mahabaleshwar"],
["Private Cab Mumbai to Mahabaleshwar","Mumbai to Mahabaleshwar Round Trip Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Comfortable Hill Station Travel",
    WhyChoosedescription: "Velocity Cabs offers smooth and comfortable Mumbai to Mahabaleshwar cab service, perfect for weekend getaways, family trips, and nature tours to the beautiful hill station."
  },
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving through ghat sections and hill roads, ensuring safe navigation, smooth driving, and a relaxed travel experience."
  },
  {
    WhyChooseheading: "Transparent Cab Pricing",
    WhyChoosedescription: "Velocity Cabs provides transparent pricing for Mumbai to Mahabaleshwar cab bookings. Customers receive clear fare details including toll charges and driver allowance with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Our Mumbai to Mahabaleshwar cab service operates 24/7. Whether you plan an early morning trip or late-night return, Velocity Cabs ensures reliable travel anytime."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well maintained, and regularly cleaned to provide a comfortable and enjoyable long-distance travel experience."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Velocity Cabs offers flexible travel options including one-way cab service, round-trip bookings, and customized travel plans for Mumbai to Mahabaleshwar trips."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Outstation Travel Service",
    WhyChoosedescription: "Velocity Cabs is trusted by many travelers for Mumbai to Mahabaleshwar cab bookings due to punctual drivers, comfortable vehicles, and professional service."
  }
]
};

const faqData = [
  { question: "Do you provide Mumbai to Mahabaleshwar cab service?", answer: "Yes, Velocity Cabs provides reliable cab services from Mumbai to Mahabaleshwar for one-way and round-trip travel." },
  { question: "How far is Mahabaleshwar from Mumbai?", answer: "The distance between Mumbai and Mahabaleshwar is approximately 260 km and takes around 5 to 6 hours depending on traffic and route." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Mahabaleshwar cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "Velocity Cabs offers sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta vehicles, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services from Mumbai to Mahabaleshwar." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Can I book the cab online?", answer: "Yes, customers can easily book Mumbai to Mahabaleshwar cabs online or through phone booking." },
  { question: "Do you provide pickup from home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, railway stations, and airports across Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended especially during weekends and holiday seasons." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Saurabh Deshmukh",
    feedback:
      "A refreshing and comfortable journey from Mumbai to Mahabaleshwar. The cab was clean, the ride was smooth, and the hill drive felt very enjoyable throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "The Mumbai to Mahabaleshwar cab experience was excellent. The vehicle was well-maintained, the drive was steady, and the entire trip felt safe and relaxing.",
    rating: 5
  }
];




























const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cabs", link: "Pune-to-Mumbai-Airport-Cabs" },
{ place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cabs", link: "Pune-to-Mumbai-International-Airport-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
{ place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
{ place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
{ place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
{ place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
{ place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
{ place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
{ place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
{ place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
{ place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
{ place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
{ place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
{ place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];











const mumbaiMahabaleshwarJSON = {
  "@context": "https://schema.org",
  "@type": "TouristTrip",
  "name": "Mumbai to Mahabaleshwar Cab | Velocity Cabs",
  "description": "Book a private cab from Mumbai to Mahabaleshwar. Enjoy comfortable AC, Sedan, or SUV taxis for one-way or round-trip journeys. Ideal for outstation trips and weekend getaways.",
  "provider": {
    "@type": "Organization",
    "name": "Velocity Cabs",
    "url": "https://www.velocitycabs.com/"
  },
  "areaServed": {
    "@type": "Place",
    "name": "Mumbai, Maharashtra, India"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Mumbai to Mahabaleshwar Cab Packages",
    "itemListElement": [
      {
        "@type": "Offer",
        "name": "One Way Cab Mumbai to Mahabaleshwar",
        "description": "Private cab from Mumbai to Mahabaleshwar with AC or Sedan options.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      },
      {
        "@type": "Offer",
        "name": "Round Trip Cab Mumbai to Mahabaleshwar",
        "description": "Comfortable round-trip cab from Mumbai to Mahabaleshwar with AC, Sedan, or SUV.",
        "url": "https://www.velocitycabs.com/",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock"
      }
    ]
  }
};






  return (
    <div>
      <Helmet>
  <title>Mumbai to Mahabaleshwar Cab | Velocity Cabs +91 9136271336</title>
  <meta
    name="description"
    content="Book a private cab from Mumbai to Mahabaleshwar. AC, Sedan, and SUV options available for one-way or round-trip journeys. Comfortable outstation taxi service from Mumbai."
  />
  <script type="application/ld+json">
    {JSON.stringify(mumbaiMahabaleshwarJSON)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/108.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Velocity Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚗
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Velocity Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Velocity Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919136271336" className="pc-call">+91 9136271336</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919136271336"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919136271336" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@velocitycabs.com" className="pc-email">
        booking@velocitycabs.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Velocity Cab</strong><br />
        Prakash Residency, Sec 10E, Plot 40 Roadpali, Kalamboli 410218 Navi Mumbai, Maharashtra
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitomahabaleshwarcab;